import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ModalBasic from "../../components/ModalBasic.jsx";
import { PrimaryButton, SecondaryButton } from "../../components/Buttons.jsx";
import { requestMarketplaceLicenses } from "../../api/admin.js";
import { addToast } from "../../store/app/action.js";

const isValidEmail = (email) => /^\S+@\S+\.\S+$/.test(email);

function RequestLicensesModal({ store, setModalOpen }) {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!store) return;
    setEmail(store.email || "");
    setSubmitting(false);
  }, [store]);

  if (!store) return null;

  const trimmedEmail = email.trim();
  const emailValid = isValidEmail(trimmedEmail);
  const canSubmit = emailValid && !submitting;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setSubmitting(true);
    try {
      await requestMarketplaceLicenses(store.store_id, trimmedEmail);
      dispatch(
        addToast({
          type: "success",
          message: `License request sent to ${trimmedEmail}`,
          timer: 8,
        })
      );
      setModalOpen(null);
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Failed to request licenses";
      dispatch(
        addToast({
          type: "error",
          message,
          timer: 8,
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalBasic
      width="md"
      modalOpen={Boolean(store)}
      setModalOpen={setModalOpen}
      title="Request license documents"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <p className="text-sm text-slate-600 dark:text-slate-400">
          Email{" "}
          <span className="font-semibold text-slate-800 dark:text-slate-100">
            {store.name}
          </span>{" "}
          ({store.store_id}) asking them to upload or update their license
          documents under Settings → Licenses.
        </p>
        <div>
          <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
            Send to <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            className="form-input w-full"
            placeholder="owner@store.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={submitting}
          />
          {trimmedEmail && !emailValid && (
            <p className="text-xs text-red-500 mt-1">
              Enter a valid email address.
            </p>
          )}
        </div>
        <div className="flex gap-2 justify-end pt-4 border-t border-slate-200 dark:border-slate-700">
          <SecondaryButton
            type="button"
            onClick={() => setModalOpen(null)}
            disabled={submitting}
          >
            Cancel
          </SecondaryButton>
          <PrimaryButton type="submit" loading={submitting} disabled={!canSubmit}>
            Send request
          </PrimaryButton>
        </div>
      </form>
    </ModalBasic>
  );
}

export default RequestLicensesModal;
